import { SecurityPostureType } from "@/views/customize/data-sources/data/model";
import { ApplicationType } from "../model";

export const POSTURE_TO_APPS_MAPPING: Record<
  SecurityPostureType,
  ApplicationType[]
> = {
  information_access: ["msft_sharepoint_365", "msft_onedrive"],
  activities: [
    "msft_dynamics_sales",
    /* "az_ad_log",
    "az_resource_log",
    "aws_logs",
    "github",
    "google_workspace",
    "mip",
     "msft_admin",
    "oracle_cloud_app",
    "power_bi",
    "salesforce",
    "msft_stream",
    "hub_spot", */
  ],
  data_security: [
    "cloud_mongo_db",
    "onprem_db",
    "amazon_s3",
    "az_storage",
    "az_sql_db",
    "az_cosmos_db",
    "amazon_doc_db",
  ],
  msgs: ["exchange365"],
  insider_threat: ["msft365"],
  identities: ["msft365"],
  data_protection: [
    "msft_onedrive",
    "msft_sharepoint_365",
    "msft_teams",
    "network_file_system",
  ],
  info_governance: ["msft_onedrive", "msft_sharepoint_365", "msft_teams"],
  dlp: ["msft_onedrive", "msft_sharepoint_365", "msft_teams"],
};
